import {TableMap, TableRect} from "prosemirror-tables";
import {ResolvedPos} from "prosemirror-model";

/**
 * selectedRect from prosemirror-tables for target position
 *
 * @public
 */
export const getInTableRect = ($pos: ResolvedPos): TableRect => {
    const tableDepth = getTableDepth($pos);
    const table = $pos.node(tableDepth);
    const tableStart = $pos.start(tableDepth);
    const map = TableMap.get(table);
    const rect = map.findCell($pos.pos - tableStart);
    return { ...rect, tableStart, map, table };
}


function getTableDepth($pos: ResolvedPos): number {
    for(let depth = 1; depth <= $pos.depth; depth++) {
        if ($pos.node(-1 * depth).type.spec.tableRole === 'table') {
            return -1 * depth;
        }
    }
    return -1;
}